import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  ModalCloseButton,
} from "@chakra-ui/react";
import color from "../../../config/color";

const ChakraPopUp = ({
  children,
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
  size,
  title,
  hasDeleteButton = false,
  deleteFunction = () => {},
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      scrollBehavior="inside"
      size={size ?? "lg"}
    >
      <ModalOverlay />
      <ModalContent borderRadius="none">
        <ModalHeader bgColor={color.orange} color="white" fontSize="2xl">
          {title}
        </ModalHeader>
        <ModalCloseButton color="white" size="lg" />
        <ModalBody>{children}</ModalBody>
        <ModalFooter borderRadius="none">
          <Button
            borderRadius="full"
            px={6}
            fontSize="sm"
            colorScheme="red"
            hidden={!hasDeleteButton}
            mr={3}
            type="submit"
            isLoading={isSubmitting}
            onClick={deleteFunction}
          >
            刪除
          </Button>
          <Button
            borderRadius="full"
            px={6}
            fontSize="sm"
            colorScheme="orange"
            bgColor={color.orange}
            mr={3}
            type="submit"
            isLoading={isSubmitting}
            onClick={onSubmit}
          >
            儲存
          </Button>
          <Button
            borderRadius="full"
            px={6}
            fontSize="sm"
            colorScheme="gray"
            bgColor={color.gray}
            color="white"
            onClick={onClose}
            isLoading={isSubmitting}
          >
            取消
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ChakraPopUp;
